import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import "../../assets/styles/local/ProjectWork.css";
import { Image, Row, Col } from "react-bootstrap";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import orderPickingFilter from "../../assets/icons/orderPickingFilter.svg";
import Conthover from "../..//assets/icons/Contacthover.svg";
import InvoiceDoller from "../../assets/icons/InvoiceDoller.svg";
import blackDoller from "../../assets/icons/blackDoller.svg";
import invoiceBlueDoller from "../../assets/icons/Invoice.svg";
import bin from "../../assets/icons/Bin.svg";
import AddIcon from "../..//assets/icons/addicon.svg";
import Kebab from "../..//assets/icons/Kebab contacts.svg";
import docicons from "../../assets/icons/Group 2949.svg";
import Plusicon from "../../assets/icons/Plus.svg";
import Taskicon from "../../assets/icons/Group 2951.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import calendar from "../../assets/icons/calendar.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import upArrow from "../../assets/icons/upArrow.png";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import Image5 from "../..//assets/icons/Group 1277.svg";
import plusCircle from "../../assets/icons/plusCircle.svg";
import Loader from "../../components/Dailogs/Loader";
import AppDatePicker from "../../components/Common/AppDatePicker";
import moment from "moment";

import {
  FetchProjectWorks,
  DeleteWork,
  AddWorkTask,
  DeleteWorkTask,
  FetchActiveUser,
  ChangeStatus,
  UpdatePOTaskStatus,
  FetchWorkById,
  UpdateWorkTask,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../components/Pagination/Pagination";
import axios from "axios";
import { API_URL } from "../../redux/constants/type";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import TodoList from "../../pages/dynamic/ToDoList";

const ProjectWork = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const kebab_Popup_Ref = useRef(null);
  const sortByRef = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const projectid = window.localStorage.getItem("projectid");
  const clientid = window.localStorage.getItem("clientid");
  const isViewer = process.env.REACT_APP_IS_VIEWER;
  console.log("ASC56 Role ENV", isViewer);

  const fetchProjectWorksRes = useSelector(
    (state) => state.user.fetchProjectWorksRes,
  );

  const deleteWorkListRes = useSelector(
    (state) => state.user.deleteWorkListRes,
  );

  const addWorkTaskRes = useSelector((state) => state.user.addWorkTaskRes);
  const deletWorkTaskRes = useSelector((state) => state.user.deletWorkTaskRes);

  const UpdatePOTaskStatusResponse = useSelector(
    (state) => state.user.UpdatePOTaskStatusResponse,
  );
  const changeStatus = useSelector((state) => state.user.changeStatus);

  const updateWorkTaskRes = useSelector(
    (state) => state.user.updateWorkTaskRes,
  );

  const fetchProjectById = useSelector(
      (state) => state.user.fetchProjectById,
    );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  // variables state management start
  const [hovereff, setHovereff] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [projectWorkListData, setProjectWorkListData] = useState([]);
  const [kebabPopupShow, setKebabPopupShow] = useState(false);
  const [addTaskModalShow, setAddTaskModalShow] = useState(false);
  console.log("asc56", addTaskModalShow);
  const [selectedClientID, setSelectedClientID] = useState("");

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  useEffect(() => {
    if (fetchProjectWorksRes.status === true) {
      setProjectWorkListData(fetchProjectWorksRes.data);
      setShowLoader(false);
      setTotalPages(Math.ceil(fetchProjectWorksRes.data.length / perPage));
    }
  }, [fetchProjectWorksRes, perPage]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      kebab_Popup_Ref.current &&
      !kebab_Popup_Ref.current.contains(event.target)
    ) {
      setKebabPopupShow(false);
      setArrowOptionsRotate(false);
    }

    if (sortByRef.current && !sortByRef.current.contains(event.target)) {
      setShowShortDrop(false);
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [companyShow, setCompanyShow] = useState(false);
  const [viewByTxtShow, setViewByTxtShow] = useState("Company");

  const [workID, setWorkID] = useState("");
  const [createWorkPopup, setCreateWorkPopup] = useState(false);

  const [sortBy, setSortBy] = useState("");
  const [querystring, setQuerystring] = useState("");
  const [isUpdateTime, setIsUpdateTime] = useState(false);

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedValue, setSortedValue] = useState("Start Date");

  // sort by options start
  const sortByOption = [
    // { label: "Start Date", value: "Start Date" },
    // { label: "End Date", value: "End Date" },
    // { label: "Assignee", value: "Assignee" },
    // { label: "Equipment", value: "Equipment" },

    { label: t("Start Date"), value: "Start Date" },
    { label: t("End Date"), value: "End Date" },
    { label: t("Assignee"), value: "Assignee" },
    { label: t("Equipment"), value: "Equipment" },
  ];
  // sort by options end

  useEffect(() => {
    const sortedPayload = shortByArrow
      ? `asc-${sortedValue}`
      : `dsc-${sortedValue}`;
    // dispatch(FetchProjectWorks(querystring, sortBy));
    dispatch(FetchProjectWorks(projectid, sortedPayload));
  }, [
    addWorkTaskRes,
    changeStatus,
    UpdatePOTaskStatusResponse,
    deletWorkTaskRes,
    deleteWorkListRes,
    querystring,
    sortBy,
    shortByArrow,
    sortedValue,
    updateWorkTaskRes,
  ]);

  const [activeAllFromList, setActiveAllFromList] = useState(false);
  const [goComplete, setGoComplete] = useState("");

  // for complete Toggle start
  const [toggleComplete, setToggleComplete] = useState(false);
  const [ascTaskid, setAscTaskid] = useState("");
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedToggle, setSelectedToggle] = useState([]);

  const [active, setActive] = useState(false);
  const [selectedTaskID, setSelectedTaskID] = useState("");
  console.log("asc563", selectedTaskID);
  // for complete Toggle end

  // header pagination start.
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });
  const itemsPerPage = 10;
  const calculatePagination = (pageNumber) => {
    let records = projectWorkListData || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(itemsPerPage * (pageNumber - 1) + 1, 1),
      endRecordIndex: Math.min(itemsPerPage * pageNumber, records.length),
      totalPages: Math.ceil(records.length / itemsPerPage),
      records: records.slice(
        (pageNumber - 1) * itemsPerPage,
        pageNumber * itemsPerPage,
      ),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };
  useEffect(() => {
    calculatePagination(1);
  }, [projectWorkListData]);
  // header pagination end.

  return (
    <>
      {showLoader === true ? (
        <div
          className="text-center "
          style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
        >
          <Loader />
        </div>
      ) : (
        <>
          <div className="parent pt-3 position-relative d-none">
            <div className="outer w-100">
              <Row className="row-item px-4">
                <Col xl={4} className="p-0">
                  <div
                    onClick={() => {
                      // dispatch(RemoveDocsClientById());
                      // dispatch(EmptyProductPart());
                      // window.localStorage.removeItem("clientaddname");
                      // window.localStorage.removeItem("clientId2");
                      // window.localStorage.removeItem("_tmpCon");
                      setCreateWorkPopup(true);
                    }}
                    className={
                      roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "pointer d-none"
                        : "pointer d-flex gap-2 p-3 pb-0"
                    }
                    style={{ borderRadius: "8px" }}
                  >
                    <img src={CardAddButton} className="addDocImg" alt="" />
                    <p className="createWork">
                      {/* Create Work */}
                      {t("Create Work")}
                    </p>
                  </div>
                </Col>

                <Col xl={4} className="p-0">
                  <sortSection
                    className="d-flex gap-3 p-3 pb-0"
                    style={{ position: "relative" }}
                  >
                    <p className="sortBy">
                      {/* Sort by */}
                      {t("Sort By")}
                    </p>
                    <img
                      className={
                        shortByArrow
                          ? "downSortArrow mt-1 pointer"
                          : "upSortArrow mt-1 pointer"
                      }
                      src={upArrow}
                      alt=""
                      onClick={() => {
                        setShortByArrow(!shortByArrow);
                      }}
                    />

                    <p
                      ref={sortByRef}
                      className="datetext pointer"
                      onClick={() => setShowShortDrop(!showShortDrop)}
                    >
                      {sortedValue ? sortedValue : "Select"}
                    </p>

                    <div
                      className="sortDropDiv p-3"
                      style={{
                        transform: showShortDrop ? "scale(1)" : "scale(0)",
                        transitionDuration: "300ms",
                        left: "70px",
                        top: "0px",
                      }}
                    >
                      {sortByOption.map((item, index) => {
                        return (
                          <div
                            className={
                              sortedValue === item.label
                                ? "datetext pointer"
                                : "pointer"
                            }
                            onClick={() => {
                              setSortedValue(item.value);
                              setShowShortDrop(false);
                            }}
                          >
                            <p className="d-flex gap-">
                              {item.label}
                              {sortedValue === item.label && (
                                <p className="mb-0 ps-3">✓</p>
                              )}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </sortSection>
                </Col>

                <Col xl={4} className="add-col-item pe-0">
                  <div className="p-3 pb-0">
                    {/* header pagination start */}
                    <div className="stock-custom-pagination">
                      <div>
                        {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex}  of  ${paginationObj.totalRecords}`}
                      </div>
                      <div className="pagination-buttons">
                        <div
                          className={`update-stock-pagination-button ${
                            paginationObj.currentPage === 1 ? "disabled" : ""
                          }`}
                          onClick={() =>
                            calculatePagination(paginationObj.currentPage - 1)
                          }
                        >
                          <BsChevronLeft />
                        </div>
                        <div className="pagination-current-page">
                          {paginationObj.currentPage}
                        </div>
                        <div
                          className={`update-stock-pagination-button ${
                            paginationObj.totalPages === 0 ||
                            paginationObj.totalPages ===
                              paginationObj.currentPage
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() =>
                            calculatePagination(paginationObj.currentPage + 1)
                          }
                        >
                          <BsChevronRight />
                        </div>
                      </div>
                    </div>
                    {/* header pagination end */}
                  </div>
                </Col>
              </Row>

              <div className="ascTableWrapper px-4">
                <table className="table">
                  <thead>
                    <tr
                      className="tableHeading"
                      style={{
                        color: "#333333",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      <th>
                        {/* Work Order Name */}
                        {t("Work Order Name")}
                      </th>
                      <th>
                        {/* Work Task */}
                        {t("Work Task")}
                      </th>
                      <th>
                        {/* Start */}
                        {t("Start  ")}
                      </th>
                      <th className="d-none">Type</th>
                      <th>
                        {/* End */}
                        {t("End  ")}
                      </th>
                      <th>
                        {/* Assigned to */}
                        {t("Assigned to")}
                      </th>
                      <th>
                        {/* Equipment */}
                        {t("Equipment")}
                      </th>
                      <th></th>
                      <th style={{ width: "1%" }}>
                        {/* Complete */}
                        {t("Complete")}
                      </th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody
                    className="tabLine"
                    style={{
                      color: "#333333",
                      fontSize: "14px",
                      fontWeight: "400",
                    }}
                  >
                    {/* {projectWorkListData
                    .slice(currentPage * perPage, (currentPage + 1) * perPage) */}
                    {paginationObj.records.map((item, index) => {
                      return (
                        <tr
                          className="asc_Table_Hover"
                          // title={item.clientname.length > 10 && item.clientname}
                        >
                          <td
                            title={
                              item?.workname?.length > 10 && item?.workname
                            }
                            className="pointer"
                            style={{
                              // for 3 dots 👇
                              // whiteSpace: "pre-wrap",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "10px",
                            }}
                            onClick={() => {
                              setIsUpdateTime(true);
                              setCreateWorkPopup(true);
                              setWorkID(item.workid);
                              dispatch(FetchWorkById(item.workid));
                            }}
                          >
                            {item.workname}
                          </td>

                          {/* <td>{item.workTasks.map((x) => x.taskname)}</td> */}
                          <td>{item.workTasks[0]?.taskname}</td>

                          <td className="">
                            {moment(item.workTasks[0]?.startingDate).format(
                              "DD.MM.YYYY",
                            )}
                          </td>

                          <td className="">
                            {moment(item.workTasks[0]?.endDate).format(
                              "DD.MM.YYYY",
                            )}
                          </td>

                          <td>{item.supervisorname}</td>

                          <td>{item.workTasks[0]?.equipment}</td>

                          <td>
                            <img
                              className="invisible"
                              src={invoiceBlueDoller}
                              alt=""
                            />
                          </td>
                          {/* 
                          <td>
                            <div className="task-grid-element-2 slide-bar-position-inmobile">
                              <article
                                className={
                                  selectedToggle.find(
                                    (data) => data.pushedID === item.workid
                                  )
                                    ? "task_slider_Comp"
                                    : "task_slider"
                                }
                                style={{
                                  backgroundColor:
                                    item?.statusname === "Complete" &&
                                    "#00246a",
                                }}
                                onClick={(e) => {
                                  let index2 = selectedToggle.findIndex(
                                    (x) => x.pushedID === item.workid
                                  );

                                  if (index2 !== -1) {
                                    let data = [...selectedToggle];
                                    data.splice(index2, 1);
                                    setSelectedToggle(data);
                                    dispatch(
                                      ChangeStatus(
                                        item?.workid,
                                        process.env
                                          .REACT_APP_TASK_STATUS_PROGRESS
                                      )
                                    );
                                    return;
                                  }
                                  let pushingItem = [...selectedToggle];
                                  pushingItem.push({
                                    pushedName: item.workname,
                                    pushedID: item.workid,
                                  });
                                  setSelectedToggle(pushingItem);

                                  // if (index2 === -1) {
                                  //   let pushingItem = [...selectedToggle];
                                  //   pushingItem.push({
                                  //     pushedName: task.taskname,
                                  //     pushedID: task.taskid,
                                  //   });
                                  //   setSelectedToggle(pushingItem);
                                  // }

                                  dispatch(UpdatePOTaskStatus(item?.workid));
                                  setToggleComplete(!toggleComplete);
                                  setAscTaskid(item.workid);
                                  setCurrentIndex(index);
                                }}
                              >
                                <article
                                  className={
                                    selectedToggle.find(
                                      (data) => data.pushedID === item.workid
                                    )
                                      ? "task_slider_knob_Comp"
                                      : "task_slider_knob"
                                  }
                                  style={{
                                    left:
                                      item?.statusname === "Complete" && "46%",
                                  }}
                                ></article>
                              </article>
                            </div>
                          </td> */}

                          <td className="ps-4">
                            <div className="actionHeadTxt d-flex align-items-center gap-2">
                              {/* <p className="mb-1">Active?</p> */}
                              <label
                                htmlFor="asc_purch_Switch"
                                className="d-none"
                              >
                                Active?
                              </label>
                              <input
                                type="checkbox"
                                // id="asc_purch_Switch"
                                id={`switchToggle${item.workTasks[0]?.taskid}`}
                                className="asc_pursh_Checkbox"
                                // disabled={}
                                // checked={active}
                                // checked={task.isCompleted}
                                // checked={
                                //   item.workTasks[0]?.statusname ===
                                //     "Complete" ||
                                //   item.workTasks[0]?.statusname === "Completed"
                                //     ? 1
                                //     : 0
                                // }
                                // onChange={(e) => {
                                //   // setActive(!active);
                                //   // setSelectedTaskID(item.workTasks[0]?.taskid);
                                //   if (e.target.checked) {
                                //     dispatch(
                                //       UpdatePOTaskStatus(
                                //         item.workTasks[0]?.taskid
                                //       )
                                //     );
                                //   } else {
                                //     dispatch(
                                //       ChangeStatus(
                                //         item.workTasks[0]?.taskid,
                                //         process.env
                                //           .REACT_APP_TASK_STATUS_PROGRESS
                                //       )
                                //     );
                                //   }
                                // }}
                                checked={item.allcomplete === 0}
                                onChange={(e) => {
                                  dispatch(FetchWorkById(item.workid));
                                  setActiveAllFromList(true);
                                  if (e.target.checked) {
                                    setGoComplete("TaskComplete");
                                  } else {
                                    setGoComplete("TaskInprogress");
                                  }
                                }}
                              />
                              <label
                                // htmlFor="asc_purch_Switch"
                                htmlFor={`switchToggle${item.workTasks[0]?.taskid}`}
                                className="asc_purch_Toggle"
                              >
                                {/* <p className=''>ASC</p> */}
                              </label>
                            </div>
                          </td>

                          <td className="position-relative">
                            <img
                              className="pointer"
                              src={Kebab}
                              alt=""
                              onClick={() => {
                                setKebabPopupShow(true);
                                setSelectedClientID(item.workid);
                              }}
                            />
                            {kebabPopupShow &&
                              item.workid === selectedClientID && (
                                <div className="companyKebabPopup p-3">
                                  <div className="pointer text-end pe-2">
                                    <img
                                      src={Kebab}
                                      alt=""
                                      style={{ rotate: "90deg" }}
                                      onClick={() => {
                                        setKebabPopupShow(false);
                                      }}
                                    />
                                  </div>
                                  <div className="kebabTxt pointer">
                                    <div
                                      className="d-flex gap-2 d-none"
                                      onClick={() => {
                                        // history.push({
                                        //   pathname: "/add-contact",
                                        //   state: {
                                        //     from: "CompanyList_Screen",
                                        //     companyName: item.clientname,
                                        //   },
                                        // });
                                      }}
                                    >
                                      <img
                                        src={blackDoller}
                                        alt=""
                                        width={14}
                                      />
                                      <p>
                                        {/* Request PO */}
                                        {t("Request PO")}
                                      </p>
                                    </div>

                                    <div
                                      className="d-flex gap-2"
                                      onClick={() => {
                                        // history.push({
                                        //   pathname: "/addProject",
                                        //   state: "/project",
                                        //   ascState: {
                                        //     from: "CompanyList_Screen",
                                        //     clientName: item.clientname,
                                        //     clientId: item.clientid,
                                        //   },
                                        // });
                                        dispatch(DeleteWork(item.workid));
                                      }}
                                    >
                                      <img src={bin} alt="" width={14} />
                                      <p>
                                        {/* Delete */}
                                        {t("Delete")}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </td>
                        </tr>
                      );
                    })}
                    {projectWorkListData.length === 0 && (
                      <span className="noDataDisplay">
                        {/* No data to display! */}
                        {t("No data to display!\n")}
                      </span>
                    )}
                  </tbody>
                </table>
              </div>
              {/* <Pagination
              perPage={perPage}
              setPerPage={setPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            /> */}
            </div>
            <CreateWork
              createWorkPopup={createWorkPopup}
              setCreateWorkPopup={setCreateWorkPopup}
              projectid={projectid}
              addWorkTaskRes={addWorkTaskRes}
              projectWorkListData={projectWorkListData}
              isUpdateTime={isUpdateTime}
              setIsUpdateTime={setIsUpdateTime}
              workID={workID}
              setWorkID={setWorkID}
              deletWorkTaskRes={deletWorkTaskRes}
              activeAllFromList={activeAllFromList}
              setActiveAllFromList={setActiveAllFromList}
              goComplete={goComplete}
              setGoComplete={setGoComplete}
              UpdatePOTaskStatusResponse={UpdatePOTaskStatusResponse}
              changeStatus={changeStatus}
              setFetchTranslationList={setFetchTranslationList}
              FetchTranslationList={FetchTranslationList}
            />
          </div>

          <TodoList
            projectid={projectid}
            clientid={clientid}
            deliveryAddress={fetchProjectById.data[0]?.deliveryAddress}
          />
        </>
      )}
    </>
  );
};

const CreateWork = ({
  createWorkPopup,
  setCreateWorkPopup,
  projectid,
  addWorkTaskRes,
  projectWorkListData,
  isUpdateTime,
  setIsUpdateTime,
  workID,
  setWorkID,
  deletWorkTaskRes,
  activeAllFromList,
  setActiveAllFromList,
  goComplete,
  setGoComplete,
  UpdatePOTaskStatusResponse,
  changeStatus,
  FetchTranslationList,
}) => {
  const dispatch = useDispatch();
  const projectManagerRef = useRef(null);
  const startingDate_Popup_Ref = useRef(null);
  const complitionDate_Popup_Ref = useRef(null);
  const targetRef = useRef(null);
  const t = (key) => FetchTranslationList?.[key] || "";

  const fetchActiveUser = useSelector((state) => state.user.fetchActiveUser);
  const fetchWorkTaskByIdRes = useSelector(
    (state) => state.user.fetchWorkTaskByIdRes,
  );

  const updateWorkTaskRes = useSelector(
    (state) => state.user.updateWorkTaskRes,
  );

  const [workName, setWorkName] = useState("");
  const [taskName, setTaskName] = useState("");
  const [openAssigneeModal, setOpenAssigneeModal] = useState(false);
  const [superVisorName, setSuperVisorName] = useState("");
  const [superVisorID, setSuperVisorID] = useState("");
  const [workMultipleData, setWorkMultipleData] = useState([]);
  console.log("asc562", workMultipleData);

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  const [startingDate, setStartingDate] = useState(new Date());
  const [completionDate, setCompletionDate] = useState(new Date());
  const [dateError, setDateError] = useState(false);

  // account manager state start.
  const [projectManagerShow, setProjectManagerShow] = useState(false);
  const [projectManagerData, setProjectManagerData] = useState([]);
  const [searchProjectManager, setSearchProjectManager] = useState("");
  const [arrowOptionsRotate4, setArrowOptionsRotate4] = useState("");
  const [projectManagerName, setProjectManagerName] = useState("");
  const [projectManagerID, setProjectManagerID] = useState("");
  const [projectManagerImage, setProjectManagerImage] = useState("");
  const [selectedManagerImg, setSelectedManagerImg] = useState("");
  const [selectedManagerFName, setSelectedManagerFName] = useState("");
  const [selectedManagerLName, setSelectedManagerLName] = useState("");
  // account manager state end.

  useEffect(() => {
    if (fetchActiveUser.status === true) {
      setProjectManagerData(fetchActiveUser.data);
    }
  }, [fetchActiveUser]);

  useEffect(() => {
    if (
      UpdatePOTaskStatusResponse.status === true ||
      changeStatus.status === true ||
      deletWorkTaskRes.status === true
    ) {
      dispatch(FetchWorkById(workID));
    }
  }, [UpdatePOTaskStatusResponse, changeStatus, deletWorkTaskRes]);

  useEffect(() => {
    if (
      (fetchWorkTaskByIdRes.status === true && isUpdateTime) ||
      activeAllFromList
    ) {
      setWorkName(fetchWorkTaskByIdRes.data[0]?.workname);
      setWorkID(fetchWorkTaskByIdRes.data[0]?.workid);
      setProjectManagerName(fetchWorkTaskByIdRes.data[0]?.supervisorname);
      setProjectManagerID(fetchWorkTaskByIdRes.data[0]?.supervisorid);
      setProjectManagerImage(fetchWorkTaskByIdRes.data[0]?.supervisorimage);

      // start item pushing on same array...
      let invoiceListArray = [];

      fetchWorkTaskByIdRes.data?.forEach((item) => {
        item.workTasks.forEach((task) => {
          invoiceListArray.push({
            asc_WorkName: item.workname,
            asc_WorkSupervisor: item.supervisorname,
            asc_WorkSupervisorID: item.supervisorid,
            asc_TaskName: task.taskname,
            asc_TaskID: task.taskid,
            asc_WorkTaskID: task.worktaskid,
            asc_StatusName: task.statusname,
            asc_StatusID: task.statusid,
            asc_StartDate: new Date(task.startingDate),
            asc_EndDate: new Date(task.endDate),
            asc_calendarIsOpen: false,
            asc_calendarIsOpen2: false,
          });
        });
      });
      console.log("asc33", invoiceListArray);
      setWorkMultipleData(invoiceListArray);

      // when we complete all task toggle from list toggle👇
      if (activeAllFromList) {
        let workTasks = invoiceListArray.map((x) => ({
          worktaskid: x.asc_WorkTaskID,
          taskid: x.asc_TaskID,
          taskname: x.asc_TaskName,
          startingDate: x.asc_StartDate,
          endDate: x.asc_EndDate,
          equipment: "",
          statusid:
            goComplete === "TaskComplete"
              ? process.env.REACT_APP_TASK_STATUS_COMPLETE
              : process.env.REACT_APP_TASK_STATUS_PROGRESS,
        }));

        dispatch(
          UpdateWorkTask(
            fetchWorkTaskByIdRes.data[0]?.workid,
            projectid,
            fetchWorkTaskByIdRes.data[0]?.workname,
            fetchWorkTaskByIdRes.data[0]?.supervisorid,
            workTasks,
          ),
        );
        setActiveAllFromList(false);
      }
    }
  }, [fetchWorkTaskByIdRes, isUpdateTime]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      projectManagerRef.current &&
      !projectManagerRef.current.contains(event.target)
    ) {
      setOpenAssigneeModal(false);
    }

    if (
      startingDate_Popup_Ref.current &&
      !startingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen(false);
    }
    if (
      complitionDate_Popup_Ref.current &&
      !complitionDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen2(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const handleInputChange = (index, field, value) => {
    const newItems = [...workMultipleData];
    newItems[index][field] = value;

    // Close all other calendars when one is opened.
    if (field === "asc_calendarIsOpen" && value === true) {
      newItems.forEach((item, i) => {
        if (i !== index) {
          item.asc_calendarIsOpen = false;
        }
      });
    }
    setWorkMultipleData(newItems);
  };

  const handleAddSection = () => {
    setTimeout(() => {
      // Trigger a click event on the element with the class 'fas fa-bars'.
      const targetElement = document.querySelector(".ascClicked ");
      console.log("ascTarget", targetElement);
      if (targetElement) {
        targetElement.click(); // Simulate a click event.
      } else {
        console.log('Element with class "ascClicked" not found.');
      }
    }, 100);
  };

  // const onButtonClick = () => {
  //   targetRef.current.click();
  // };

  const handleAddSection2 = () => {
    if (targetRef.current) {
      console.log("ascTarget", targetRef.current);
      targetRef.current.click(); // Trigger the click event directly.
    } else {
      console.log("Target element not found.");
    }
  };

  return (
    createWorkPopup && (
      <div
        className="cretaeWorkDiv p-3 position-absolute"
        style={{ top: "15px", left: "15px" }}
      >
        <div className="d-flex justify-content-between">
          <p className="addWork mb-0">
            {/* {isUpdateTime ? "Work Order" : "Add Work"} */}
            {isUpdateTime ? t("Work Order") : t("Add Work")}
          </p>
          <img
            src={XiconCircle}
            alt=""
            className="pointer"
            width={18}
            onClick={() => {
              setCreateWorkPopup(false);
              setIsUpdateTime(false);
              setProjectManagerShow(false);
              setArrowOptionsRotate4(false);
              setWorkMultipleData([]);
              setWorkName("");
              setProjectManagerName("");
              setProjectManagerImage("");
              setProjectManagerID("");
            }}
          />
        </div>

        <div className="row">
          <div className="asc-input-container col-md-4 col-12" id="ascInput">
            <label
              className="asc-label-top ClientNameText"
              style={{ background: "#fff" }}
            >
              {/* Work Name */}
              {t("Work Name")}
            </label>

            <input
              type="text"
              // disabled
              className="asc_NormalInput ps-4"
              style={{
                fontSize: "14px",
                fontWeight: "400",
                color: "#323232",
                width: "100%",
                background: "white",
              }}
              placeholder="Work Name"
              value={workName}
              onChange={(e) => {
                setWorkName(e.target.value);
                // setChangeComp("asc");
              }}
            />
          </div>

          {/* SuperVisor start */}
          <div className="asc-input-container col-md-6 col-12" id="ascInput">
            <label className="asc-label-top ClientNameText">
              {/* Supervisor */}
              {t("Supervisor")}
            </label>

            <div
              className="asc_Client_Input_Div_For_LongDiv22 p-2"
              ref={projectManagerRef}
              style={{ width: "auto" }}
            >
              <div
                className="d-flex gap-2"
                onClick={() => {
                  setProjectManagerShow(!projectManagerShow);
                  setArrowOptionsRotate4(!arrowOptionsRotate4);
                }}
              >
                {selectedManagerImg || projectManagerImage ? (
                  <img
                    src={selectedManagerImg || projectManagerImage}
                    alt=""
                    className="plusCircle mt-1"
                  />
                ) : selectedManagerFName ? (
                  <div className="plusCircleAssignee mt-1">
                    {selectedManagerLName
                      ? selectedManagerFName[0] + "" + selectedManagerLName[0]
                      : selectedManagerFName?.slice(0, 2)}
                  </div>
                ) : (
                  <img
                    src={plusCircle}
                    alt=""
                    className="plusCircle pointer mt-1 "
                  />
                )}

                <p
                  className="mb-1 pt-2"
                  // title={
                  //   projectManagerName?.length > 10 &&
                  //   projectManagerName
                  // }
                  style={{
                    color: "#333333",
                    fontWeight: "700",
                    // for 3 dots 👇
                    // whiteSpace: "pre-wrap",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    // maxWidth: "10px",
                  }}
                >
                  {projectManagerName
                    ? projectManagerName
                    : // : "Select a Supervisor"
                      t("Select a Supervisor ")}
                </p>

                {projectManagerName ? (
                  <img
                    src={Xicon}
                    className="xicon pointer ms-auto h-auto"
                    alt=""
                    onClick={() => {
                      setSearchProjectManager("");
                      setProjectManagerName("");
                      setProjectManagerID("");
                      setSelectedManagerImg("");
                      setSelectedManagerFName("");
                      setSelectedManagerLName("");
                      // setChangeComp("asc");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={
                      arrowOptionsRotate4
                        ? "upArrow ms-auto h-auto"
                        : "downArrow ms-auto h-auto"
                    }
                    alt=""
                    onClick={() => {
                      setProjectManagerShow(!projectManagerShow);
                      setArrowOptionsRotate4(!arrowOptionsRotate4);
                    }}
                  />
                )}
              </div>

              {projectManagerShow && (
                <div
                  className="asc_Custom_Select_Outer22"
                  style={{
                    transform: projectManagerShow ? "scale(1)" : "scale(0)",
                    transitionDuration: "300ms",
                    top: "50px",
                  }}
                >
                  <p className="asc_Search_Client_Text pt-2 ps-2">
                    <input
                      type="text"
                      className="asc_Client_Input_For_Long ps-2"
                      placeholder="Search Supervisor..."
                      value={searchProjectManager}
                      onChange={(e) => {
                        setSearchProjectManager(e.target.value);
                        setProjectManagerShow(true);
                      }}
                    />
                  </p>

                  <section
                    className="asc_Search_List pt-0 p-3"
                    id="ascSelectBox"
                  >
                    {projectManagerData
                      .filter((x) =>
                        x.firstname
                          ?.toLowerCase()
                          .includes(searchProjectManager),
                      )
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="pt-2"
                            onClick={() => {
                              setSearchProjectManager("");
                              setProjectManagerName(
                                `${item.firstname}
                                                     ${item.lastname}`,
                              );
                              setProjectManagerID(item.userid);
                              setProjectManagerShow(false);

                              setSelectedManagerImg(item.imageurl);
                              setSelectedManagerFName(item.firstname);
                              setSelectedManagerLName(item.lastname);
                              // setChangeComp("asc");
                            }}
                          >
                            <div className="d-flex gap-2 align-items-center">
                              {item.imageurl ? (
                                <img
                                  src={item.imageurl}
                                  alt=""
                                  className="assigneeIMG"
                                />
                              ) : (
                                <div
                                  className="assigneeAbbr"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                >
                                  {item.lastname
                                    ? item?.firstname[0] +
                                      "" +
                                      item?.lastname[0]
                                    : item?.firstname?.slice(0, 2)}
                                </div>
                              )}
                              <p className="mb-0">
                                {`${item.firstname}
                                                ${item.lastname}`}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    {projectManagerData.length === 0 && (
                      <span className="noDataDisplay">
                        {/* No data to display! */}
                        {t("No data to display!\n")}
                      </span>
                    )}
                  </section>
                </div>
              )}
            </div>
          </div>
          {/* SuperVisor end */}
        </div>

        <div className="row align-items-baseline pt-4">
          <p className="col-md-8 col-12 multiFun mb-0">
            {/* Work Task */}
            {t("Work Task")}
          </p>
          <div className="col-md-2 col-12 d-flex gap-2 ps-5">
            <p
              className={
                workName === "" || projectManagerID === ""
                  ? "pointerEvent mb-0 multiAdd"
                  : "mb-0 multiAdd"
              }
              // onClick={handleAddSection}
              onClick={handleAddSection2}
            >
              Add
            </p>
            <img
              ref={targetRef}
              // className="pointer ascClicked"
              className={
                workName === "" || projectManagerID === ""
                  ? "pointerEvent pointer ascClicked"
                  : "pointer ascClicked"
              }
              src={Plusicon}
              alt=""
              width={15}
              onClick={() => {
                // dispatch(
                //   SendInvoice(invoiceId, email, invoiceCode)
                // );
                // setGenEmailPopupShow(false);

                let workData = [...workMultipleData];
                workData.push({
                  asc_WorkName: workName,
                  asc_WorkSupervisor: superVisorName,
                  asc_WorkSupervisorID: superVisorID,
                  asc_TaskName: "",
                  asc_StartDate: new Date(),
                  asc_EndDate: new Date(),
                  asc_calendarIsOpen: false,
                  asc_calendarIsOpen2: false,
                });

                setWorkMultipleData(workData);

                // setEnterGenEmail("");
                // setGenEmailName("");
              }}
            />
          </div>

          <div className="col-md-2 col-12">
            {isUpdateTime && <p className="mb-0">Complete ?</p>}
          </div>
        </div>

        {/* Multiple Work start */}
        {workMultipleData.map((item, index) => {
          return (
            <div className="pt-1 row align-items-center">
              <div
                className="asc-input-container col-md-4 col-12"
                id="ascInput"
              >
                <label
                  className="asc-label-top ClientNameText"
                  style={{ background: "#fff" }}
                >
                  {/* Task Name */}
                  {t("Task Name")}
                </label>

                <input
                  type="text"
                  // disabled
                  className="asc_NormalInput ps-4"
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#323232",
                    width: "100%",
                    background: "white",
                  }}
                  // placeholder="Task Name"
                  placeholder={t("Task Name")}
                  value={item.asc_TaskName}
                  onChange={(e) => {
                    // setTaskName(e.target.value);
                    // setChangeComp("asc");
                    handleInputChange(index, "asc_TaskName", e.target.value);
                  }}
                />
              </div>

              <div className="col-md-3 col-12">
                <div className="asc-input-container" id="ascInput">
                  <label className="asc-label-top projectNameText">
                    {/* Start Date */}
                    {t("Start Date")}
                  </label>
                  <div
                    className="projectManagerInput ps-2 flexContainer gap-1"
                    id="CalendarCssTT"
                    ref={startingDate_Popup_Ref}
                  >
                    <img
                      className="calendarIcon pointer"
                      // onClick={() => setCalendarIsOpen((p) => !p)}
                      onClick={() => {
                        handleInputChange(
                          index,
                          "asc_calendarIsOpen",
                          !item.asc_calendarIsOpen,
                        );
                      }}
                      src={calendar}
                      alt=""
                    />
                    <AppDatePicker
                      // open={calendarIsOpen}
                      // selected={startingDate}
                      open={item.asc_calendarIsOpen}
                      selected={item.asc_StartDate}
                      onChange={(val) => {
                        // setStartingDate(val);
                        // setCalendarIsOpen(false);
                        handleInputChange(index, "asc_StartDate", val);
                        handleInputChange(
                          index,
                          "asc_calendarIsOpen",
                          !item.asc_calendarIsOpen,
                        );
                      }}
                      onSelect={(d, event) => {
                        setDateError(false);
                        event.preventDefault();
                      }}
                      isError={dateError}
                      error={setDateError}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  {dateError && (
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        marginTop: "5px",
                      }}
                    >
                      <div class="warning-icon">!</div>
                      <div class="warning-message">
                        Please select a valid date.
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-3 col-12">
                <div className="asc-input-container" id="ascInput">
                  <label className="asc-label-top projectNameText">
                    {/* End Date */}
                    {t("End Date")}
                  </label>
                  <div
                    className="projectManagerInput ps-2 flexContainer gap-2"
                    id="CalendarCssTT22"
                    ref={complitionDate_Popup_Ref}
                  >
                    <img
                      className="calendarIcon pointer"
                      // onClick={() => setCalendarIsOpen2((p) => !p)}
                      onClick={() => {
                        handleInputChange(
                          index,
                          "asc_calendarIsOpen2",
                          !item.asc_calendarIsOpen2,
                        );
                      }}
                      src={calendar}
                      alt=""
                    />
                    <AppDatePicker
                      // open={calendarIsOpen2}
                      // selected={completionDate}
                      open={item.asc_calendarIsOpen2}
                      selected={item.asc_EndDate}
                      onChange={(val) => {
                        // setCompletionDate(val);
                        // setCalendarIsOpen2(false);
                        handleInputChange(index, "asc_EndDate", val);
                        handleInputChange(
                          index,
                          "asc_calendarIsOpen2",
                          !item.asc_calendarIsOpen2,
                        );
                      }}
                      onSelect={(d, event) => {
                        setDateError(false);
                        event.preventDefault();
                      }}
                      isError={dateError}
                      error={setDateError}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                  {dateError && (
                    <div
                      style={{
                        display: "flex",
                        gap: "5px",
                        marginTop: "5px",
                      }}
                    >
                      <div class="warning-icon">!</div>
                      <div class="warning-message">
                        Please select a valid date.
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-1 col-12 p-0">
                <img
                  className="pointer mt-3"
                  src={bin}
                  width={15}
                  alt=""
                  onClick={() => {
                    if (isUpdateTime) {
                      dispatch(DeleteWorkTask(item.asc_WorkTaskID));
                    } else {
                      let data = [...workMultipleData];
                      data.splice(index, 1);
                      setWorkMultipleData(data);
                    }
                  }}
                />
              </div>

              <div className="col-md-1 col-12 p-0">
                {isUpdateTime && (
                  <div className="actionHeadTxt d-flex align-items-center gap-2">
                    {/* <p className="mb-1">Active?</p> */}
                    <label htmlFor="asc_purch_Switch" className="d-none">
                      Active?
                    </label>
                    <input
                      type="checkbox"
                      // id="asc_purch_Switch"
                      id={`switchToggle2${item?.asc_TaskID}`}
                      className="asc_pursh_Checkbox"
                      // disabled={}
                      // checked={active}
                      // checked={task.isCompleted}
                      checked={
                        item?.asc_StatusName === "Complete" ||
                        item?.asc_StatusName === "Completed"
                          ? 1
                          : 0
                      }
                      onChange={(e) => {
                        // setActive(!active);
                        // setSelectedTaskID(item.workTasks[0]?.taskid);
                        if (e.target.checked) {
                          dispatch(UpdatePOTaskStatus(item?.asc_TaskID));
                        } else {
                          dispatch(
                            ChangeStatus(
                              item?.asc_TaskID,
                              process.env.REACT_APP_TASK_STATUS_PROGRESS,
                            ),
                          );
                        }
                      }}
                    />
                    <label
                      // htmlFor="asc_purch_Switch"
                      htmlFor={`switchToggle2${item?.asc_TaskID}`}
                      className="asc_purch_Toggle mt-3"
                    >
                      {/* <p className=''>ASC</p> */}
                    </label>
                  </div>
                )}
              </div>
            </div>
          );
        })}

        {/* Multiple Work end */}

        <div className="mt-5">
          <button
            id="ascButtonDisabled"
            disabled={
              workName === "" ||
              projectManagerID === "" ||
              workMultipleData.length === 0 ||
              workMultipleData.some((x) => x.asc_TaskName === "")
            }
            className="button_invo mt-3 pt-3 mx-auto"
            onClick={(e) => {
              if (isUpdateTime) {
                let workTasks = workMultipleData.map((x) => ({
                  worktaskid: x.asc_WorkTaskID,
                  taskid: x.asc_TaskID,
                  taskname: x.asc_TaskName,
                  startingDate: x.asc_StartDate,
                  endDate: x.asc_EndDate,
                  equipment: "",
                  statusid: x.asc_StatusID,
                }));

                dispatch(
                  UpdateWorkTask(
                    workID,
                    projectid,
                    workName,
                    projectManagerID,
                    workTasks,
                  ),
                );
              } else {
                let workTask = workMultipleData.map((x) => ({
                  taskname: x.asc_TaskName,
                  startingDate: x.asc_StartDate,
                  endDate: x.asc_EndDate,
                }));

                dispatch(
                  AddWorkTask(workName, projectid, projectManagerID, workTask),
                );
              }
              setCreateWorkPopup(false);
            }}
          >
            <p>{isUpdateTime ? "Change" : "Add"}</p>
          </button>
        </div>
      </div>
    )
  );
};

export default ProjectWork;
